import React from 'react';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import Footer from '../../components/shared/Footer';
import PageHelmet from '../../components/shared/PageHelmet';
import HomeOneHeader from '../Home/HomeOneHeader/HomeOneHeader';
import PortfolioArea from './PortfolioArea/PortfolioArea';

const Portfolio = () => {
   return (
      <>
         <PageHelmet pageTitle="JRD Transportation Equipment" />

         <HomeOneHeader/>
         <CommonPageHeader title="Our Equipment" subtitle="Equipment" />
         <PortfolioArea/>
         <Footer/>
      </>
   );
};

export default Portfolio;